import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchActivityFieldsRequest,
  clearActivityFields,
} from "../store/activityFormSlice";
import {
  selectActivityFields,
  selectAreActivityFieldsLoading,
  selectActivityFieldsError,
} from "../store/selectors";

export function useActivityFields(selectedTemplateShortName, renderType = "new") {
  const dispatch = useDispatch();
  const activityFields = useSelector(selectActivityFields);
  const areFieldsLoading = useSelector(selectAreActivityFieldsLoading);
  const fieldsError = useSelector(selectActivityFieldsError);

  useEffect(() => {
    if (!selectedTemplateShortName) {
      dispatch(clearActivityFields());
      return;
    }
    dispatch(
      fetchActivityFieldsRequest({ shortName: selectedTemplateShortName, renderType }),
    );
  }, [selectedTemplateShortName, dispatch]);

  return { activityFields, areFieldsLoading, fieldsError };
}